import noop from 'lodash/fp/noop'
import { authToken } from '../token'

type AuthTokenWatcherProps = {
  onLogin: (authToken: string) => void
  onLogout: () => void
  onReset?: () => void
}

let isLogin: boolean | null = null
let prevAuthToken: string | undefined

const checkAuthToken = ({
  onLogin,
  onLogout,
  onReset = noop,
}: AuthTokenWatcherProps) => {
  const token = authToken.getToken()
  const isInit = isLogin === null

  if (!isLogin && token) {
    isLogin = true
    onLogin(token)
  } else if (isLogin && !token) {
    isLogin = false
    onLogout()
  } else if (isInit && !token) {
    isLogin = false
    onReset()
  } else if (token && prevAuthToken && token !== prevAuthToken) {
    isLogin = true
    onLogin(token)
  }

  prevAuthToken = token
}

const setWasLogged = (newWasLogged: boolean | null) => (isLogin = newWasLogged)

const setPrevAuthToken = (newPrevAuthToken?: string) =>
  (prevAuthToken = newPrevAuthToken)

const run = (props: AuthTokenWatcherProps) => {
  const check = () => checkAuthToken(props)
  const cancelId = setInterval(check, 500)

  check()

  return () => clearInterval(cancelId)
}

export const authTokenWatcher = { run, setWasLogged, setPrevAuthToken }
